<template>
  <div id="Index">
    <jw-navigation>
      <banner></banner>

      <div style="width: 100%;display: flex;flex-direction: row;justify-content: space-between;padding: 10px;">
        <div v-for="(album,index) in albums" :key="index" style="width: 24%;background-color: #FFFFFF;border-radius: 5px;cursor: pointer;" @click="onClickAlbum(album)">
          <img :src="album['cover']" style="width: 100%;height: 180px;object-fit: cover;border-top-left-radius: 5px;border-top-right-radius: 5px;">
          <div style="display: flex;flex-direction: row;justify-content: space-between;margin: 5px;">
            <p>
              {{album['album_name']}}
            </p>
            <p>
              {{album['photo_count']}}
            </p>
          </div>
        </div>

      </div>

      <div style="text-align: center;margin-top: 10px;">
        <Page
            @on-change="handlePageChangeAction"
            @on-page-size-change="handlePageSizeChangeAction"
            :total="totalCount"
            :page-size="pageSize"
            show-sizer
        />
      </div>
    </jw-navigation>
  </div>
</template>

<script>
import Banner from "@/views/web/home/components/Banner.vue";

import {getPhotoAlbumList} from "@/request/web/photos";

export default {
  name: "Index",
  components: {
    Banner
  },
  data() {
    return {
      albums: [],
      pageIndex: 1,
      pageSize: 10,
      totalCount: 0,
      filter: {}
    }
  },
  created() {
    this.onGetPhotoAlbumList()
  },
  mounted() {
  },
  // 观察者
  watch: {},
  // 计算属性
  computed: {},
  methods: {
    onClickAlbum(album) {
      this.$router.push(`/photos/${album['album_id']}`)
    },
    handlePageChangeAction(pageIndex) {
      this.pageIndex = pageIndex;
      this.onGetPhotoAlbumList()
    },
    handlePageSizeChangeAction(size) {
      this.pageIndex = 1;
      this.pageSize = size;
      this.onGetPhotoAlbumList()
    },
    onGetPhotoAlbumList() {
      getPhotoAlbumList({ pageIndex: this.pageIndex, pageSize: this.pageSize, filter: this.filter }).then(res=> {
        let { list, total_count } = res.data.data;
        this.totalCount = total_count;
        this.albums = list
      })
    }
  }
}
</script>

<style scoped>

</style>
